import React, { useEffect, Children } from 'react';
import { motion } from 'framer-motion';
import { LinkedinIcon } from 'lucide-react';
export function AboutPage() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  const container = {
    hidden: {
      opacity: 0
    },
    show: {
      opacity: 1,
      transition: {
        staggerChildren: 0.15,
        delayChildren: 0.2
      }
    }
  };
  const item = {
    hidden: {
      opacity: 0,
      y: 40
    },
    show: {
      opacity: 1,
      y: 0,
      transition: {
        duration: 1,
        ease: [0.19, 1, 0.22, 1]
      }
    }
  };
  const experiences = [{
    period: '2022– 2026',
    company: 'Meta',
    title: 'Product Designer',
    description: 'Led monetization and messaging platform product design, including Messaging Ads and Shop Ads.'
  }, {
    period: '2019– 2022',
    company: 'Huge',
    title: 'Associate Design Director',
    description: 'Led 0→1 product initiatives and product strategy for clients including Yohana, Google, and Samsung.'
  }, {
    period: '2017– 2019',
    company: 'Upgrade',
    title: 'Senior Product Designer',
    description: 'Defined early product foundations across consumer products and internal tools.'
  }, {
    period: '2013– 2017',
    company: 'SapientRazorfish',
    title: 'Senior Art Director',
    description: 'Led visual design and digital brand experiences for global clients across web, mobile, and campaigns.'
  }];
  return <motion.article variants={container} initial="hidden" animate="show" className="w-full px-6 md:px-12 py-24" data-id="element-92" data-mp="32l0fbpizbv2h">
      <div className="max-w-[760px] mx-auto w-full" data-id="element-93" data-mp="2tt87lmlcb01l">
        {/* About Me Section */}
        <motion.h1 variants={item} className="text-[36px] md:text-[42px] font-bold text-ink tracking-tight mb-10" data-id="element-94" data-mp="3hj2n6bx1n2pj">
          About me
        </motion.h1>

        <motion.p variants={item} className="text-[18px] md:text-[20px] text-ink leading-[1.7] mb-8 font-[300]" data-id="element-95" data-mp="3mblzz6nwptta">
          I'm a product designer who works on complex products and ecosystems,
          helping teams navigate ambiguity and turn complexity into clear
          product direction.
        </motion.p>

        <motion.p variants={item} className="text-[18px] md:text-[20px] text-ink leading-[1.7] mb-12 font-[300]" data-id="element-96" data-mp="3h9a7tcjwdj4m">
          My work spans early-stage concepts to large-scale platforms, focusing
          on systems thinking, user experience, and scalable product strategy.
          I'm interested in products that solve meaningful user problems and
          drive business impact.
        </motion.p>

        {/* CTA Buttons */}
        <motion.div variants={item} className="flex flex-col sm:flex-row items-stretch sm:items-center gap-4 sm:gap-5 mb-32" data-id="element-97" data-mp="2yg6fbuif1cbl">
          <a href="mailto:wshihwen@gmail.com" className="inline-flex items-center justify-center px-8 sm:px-14 py-4 bg-ink text-white text-[16px] font-bold tracking-wide hover:bg-black/80 transition-colors" data-id="element-98" data-mp="2pim7g2q1shs0">
            Email me
          </a>
          <a href="https://www.linkedin.com/in/wshihwen" target="_blank" rel="noopener noreferrer" className="inline-flex items-center justify-center px-8 sm:px-14 py-4 border-2 border-ink text-ink text-[16px] font-bold tracking-wide hover:bg-ink hover:text-white transition-colors" data-id="element-99" data-mp="1dzp3zkj9scjh">
            LinkedIn
          </a>
        </motion.div>

        {/* Experience Section */}
        <motion.div variants={item} data-id="element-100" data-mp="v7w6bct9a35f">
          <h2 className="text-[36px] md:text-[42px] font-bold text-ink tracking-tight mb-12" data-id="element-101" data-mp="1007bov6rmh5d">
            Experience
          </h2>

          <div className="flex flex-col" data-id="element-102" data-mp="2js26vqc1y4u">
            {experiences.map((exp, index) => <motion.div key={index} variants={item} className="flex flex-col md:grid md:grid-cols-[180px_1fr] gap-1 md:gap-6 py-8 border-b border-stone-300 last:border-b-0" data-id="element-103" data-mp="7j4lx7lwqp37" data-mpi={index}>
                <span className="hidden md:block text-[16px] text-ink font-light whitespace-nowrap" data-id="element-104" data-mp="259bggppmyght">
                  {exp.period}
                </span>
                <div data-id="element-105" data-mp="2e7wv49rzlbdb">
                  <p className="text-[18px] md:text-[20px] text-ink font-bold mb-1" data-id="element-106" data-mp="2e7df4ylwcx1x">
                    {exp.company}
                  </p>
                  <p className="text-[16px] text-stone-500 font-light mb-2 md:hidden" data-id="element-107" data-mp="2syvy95a1z7pi">
                    {exp.title} · {exp.period}
                  </p>
                  <p className="hidden md:block text-[18px] md:text-[20px] text-ink mb-3" data-id="element-108" data-mp="31wg64x2f8293">
                    {exp.title}
                  </p>
                  {exp.description && <p className="text-[16px] text-ink leading-[1.6] font-[300]" data-id="element-109" data-mp="17krm4ghc19hu">
                      {exp.description}
                    </p>}
                </div>
              </motion.div>)}
          </div>
        </motion.div>
      </div>
    </motion.article>;
}